import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgMenu03 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 12h18M3 6h18M3 18h12"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgMenu03)
export default ForwardRef
